<template>
  <div class="footer">
    &copy; Netzlab GmbH.
  </div>
</template>

<style scoped>
  .footer {
    background-color: #e0e0e0;
    height: 20px;
    font-size: 12px;
    display: flex;
    justify-content: flex-end;
    color: #2e426b;
    align-items: center;
    padding-right: 1em;
  }
a {
  color: white;
}
</style>

<script>
export default {
    name: "netzlab-footer"
};
</script>
